import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import React from "react";

const ChevronUpIconSvg: React.FC<Partial<CustomIconComponentProps>> = (
  props,
) => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.0793 0.703125C4.32676 0.715007 4.59799 0.836124 4.81758 1.05566L7.64571 3.88379C8.03623 4.27431 8.11536 4.82918 7.82247 5.12207C7.52947 5.41439 6.97547 5.33557 6.58516 4.94531L3.99922 2.35938L1.41426 4.94531C1.02383 5.33544 0.469796 5.41469 0.176958 5.12207C-0.115936 4.82918 -0.0368089 4.27431 0.353715 3.88379L3.18184 1.05566C3.40156 0.835947 3.6735 0.71491 3.9211 0.703125H4.0793Z"
      fill="black"
      fillOpacity="0.85"
    />
  </svg>
);

export const ChevronUpIcon: React.FC<Partial<CustomIconComponentProps>> = (
  props,
) => <Icon component={ChevronUpIconSvg} {...props} />;
